import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MandateSwitchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.mandateSwitch();
    }
}
export default MandateSwitchUseCase;
